export const DEFAULT_JINGLES = [
  { label: "Abenteurlich", value: "Abenteurlich" },
  { label: "Aufregend", value: "Aufregend" },
  { label: "Business", value: "Business" },
  { label: "Inspirierend", value: "Inspirierend" },
  { label: "Intensiv", value: "Intensiv" },
  { label: "No sound", value: "NO_MUSIC" },
  { label: "Nostalgisch", value: "Nostalgisch" },
  { label: "Ruhig", value: "Ruhig" },
  { label: "Smooth", value: "Smooth" },
  { label: "Sonnig", value: "Sonnig" },
  { label: "Süß", value: "Süß" },
  { label: "Vergnügt", value: "Vergnügt" }
];

export const DEFAULT_FORMALITIES = [
  { label: "Sie", value: "Sie" },
  { label: "Du", value: "Du" }
];

export const DEFAULT_SOUNDS = [
  { label: "👱🏻‍♂️ Männlich", value: "male" },
  { label: "👩🏻‍🦰 Weiblich", value: "female" }
];

export const DEFAULT_LANGUAGES = [
  { label: "German", value: "German" },
  { label: "English", value: "English" },
  { label: "Spanish", value: "Spanish" }
];

export const ERROR_MAPPING = {
  "Google/Microsoft TTS-API failed. Check your SSML statements.": "tts_problem_processing_request",
  "Counldn't download music file. Ensure that it exisits in the Jingles folder on Google Storage":
    "tts_audio_missing",
  "Generated speech would exceed 30 sec.": "tts_text_too_long",
  "Failed to add music": "tts_failed_added_music",
  "Upload to bucket failed": "tts_upload_failed",
  null: "tts_null_error"
};

export const DEFAULT_GENERATION_ERROR = "tts_audio_generation_default_error";
